import type { ChartExploreContext } from "src/analytics/copilot/chartExploreContext";
import { DashboardPinChart } from "src/analytics/dashboard/DashboardPinChart";
import {
  DASHBOARD_GRID_CLASS,
  DASHBOARD_GRID_COLUMNS_STYLE,
} from "src/analytics/dashboard/dashboardGridLayout";
import type { LabelDictionaries } from "src/analytics/metrics/VisualizeMetrics/specialDomainScaling";
import type { Pin, Realm } from "src/clients/analytics-dashboard";

export const StaticPinGrid: React.FC<{
  pins: Pin[];
  realm: Realm;
  realmId: string;
  labelDictionaries: LabelDictionaries;
  dashboardId?: string;
  onExploreWithCopilot?: (structuredInput: ChartExploreContext) => void;
}> = ({
  pins,
  realm,
  realmId,
  labelDictionaries,
  dashboardId,
  onExploreWithCopilot,
}) => (
  <div className={DASHBOARD_GRID_CLASS} style={DASHBOARD_GRID_COLUMNS_STYLE}>
    {pins.map((pin) => (
      <DashboardPinChart
        key={pin.id}
        dashboardId={dashboardId}
        labelDictionaries={labelDictionaries}
        onExploreWithCopilot={onExploreWithCopilot}
        pin={pin}
        realm={realm}
        realmId={realmId}
      />
    ))}
  </div>
);
